import { render, staticRenderFns } from "./Comfirm.vue?vue&type=template&id=3509da33&scoped=true&"
import script from "./Comfirm.vue?vue&type=script&lang=js&"
export * from "./Comfirm.vue?vue&type=script&lang=js&"
import style0 from "./Comfirm.vue?vue&type=style&index=0&id=3509da33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509da33",
  null
  
)

export default component.exports